import dynamic from "next/dynamic";

export const ContentAccordions = dynamic(() => import("./component"));
